import { render, staticRenderFns } from "./CardVictoryPoints.vue?vue&type=template&id=b510129a&"
import script from "./CardVictoryPoints.vue?vue&type=script&lang=ts&"
export * from "./CardVictoryPoints.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports